import { Strings } from './Strings';

export const getPtPtStrings = () : Strings => ({
  SESSION_EXPIRED: 'Sessão expirada',
  BOOLEAN_ATTRIBUTE_YES: 'Sim',
  BOOLEAN_ATTRIBUTE_NO: 'Não',
  PAGE_NOT_FOUND: 'A página não foi encontrada...',
  COLLECTIONS_HEADER_LABEL: 'Coleções',
  SEARCH_HEADER_LABEL: 'Pesquisa',
  INFORMATION_SLIDER_BUTTON: '+ INFORMAÇÃO',
  NEXT_SLIDER_SPAN: 'Próximo',
  PREVIOUS_SLIDER_SPAN: 'Anterior',
  SPOTLIGHT_OBJECTS_LABEL: 'Botas de equitação por medida, produzidas exclusivamente para si.',
  MENU_FOOTER_LABEL: 'Menu',
  FILTERS_LABEL: 'Filtros',
  VARIANTS_OBJECT_LABEL: 'Variantes',
  ADD_TO_CART_OBJECT_LABEL: 'Adicionar ao carrinho',
  PRODUCT_LIST_ORDER_LABEL: 'LISTA DE PRODUTOS',
  ORDER_TOTAL_LABEL: 'Total da ordem',
  CHECKOUT_ORDER_BUTTON: 'CONTINUAR PARA O CHECKOUT',
  PREVIEW_ORDER_BUTTON: 'Pré-visualização da Encomenda',
  VARIANT_ORDER_ITEM_LABEL: 'Variante',
  QUANTITY_ORDER_ITEM_LABEL: 'Quantidade',
  PRODUCT_ADDED_TOAST_LABEL: 'Producto Adicionado!',
  CHECKOUT_ORDER_TOAST_LABEL: 'Pedido Enviado!',
  COMPONENTS_OBJECT_LABEL: 'Componentes',
  ORDER_DETAIL_TITLE_LABEL: 'Detalhe da encomenda',
  ITEM_CUTOM_ATTRIBUTE_TITLE_LABEL: 'Attributos costumizados',
  SUBMIT_LABEL: 'Continuar',
  ADD_TO_CART_LABEL: 'Adicionar item ao carrinho',
  CUSTOMIZED_VARIANT: 'Personalização',
  PRODUCTLIST: 'Lista de Produtos',
  PRODUCTLISTDOCLABEL_ITEMNAME: 'Nome do produto',
  PRODUCTLISTDOCLABEL_VARIATION: 'Variante',
  PRODUCTLISTDOCLABEL_COLLECTION: 'Coleção',
  PRODUCTLISTDOCLABEL_COMPOSITION: 'Composição',
  PRODUCTLISTDOCLABEL_QUANTITY: 'Qtd.',
  NAVIGATE_BACK: 'Voltar',
  REMOVE: 'Remover',
  CLEAR_CART: 'Limpar carrinho',
  RESULTS_FOR: 'resultados para',
  NO_CONTENT_TEXT: 'Sem imagem disponível',
  STANDARD: 'Padrão',
  PARTS: 'Partes',
  CUSTOMIZATIONS: 'Personalizações',
  PRICE: 'Preço',
  TOTAL: 'Total',
  QUANTITY: 'Quantidade',
  MEASURES: 'Medidas',
  CUSTOM_ATTRIBUTES: 'Atributos Personalizados',
  LOGIN_SUCCESSFUL: 'Autenticação bem sucedida!',
  LOGIN_CREDENTIALS_NOT_VALID: 'As credenciais apresentadas não são validas para este utilizador.',
  LOGIN_UNKNOWN_ERROR: 'Erro desconhecido',
  LOGIN_RECOVER_PASSWORD: 'Recuperar Password',
  LOGIN_CHANGE_PASSWORD: 'Alterar password',
  LOGIN_USERNAME: 'Nome de utilizador',
  LOGIN_PASSWORD: 'Password',
  LOGIN_OLD_PASSWORD: 'Password antiga',
  LOGIN_NEW_PASSWORD: 'Nova password',
  LOGIN_NEW_PASSWORD_REPEAT: 'Repetir nova password',
  LOGIN_ACTION_LOGIN: 'Autenticar',
  RECOVER_PASSWORD_MESSAGE: 'Foi enviada uma nova password para o seu email.',
  CHANGE_PASSWORD_SUCCESSFUL_MESSAGE: 'Password alterada com sucesso.',
  CHANGE_PASSWORD_ERROR_MESSAGE: 'Ocorreu um erro ao tentar alterar a password.',
  CHANGE_PASSWORD_PASSWORDS_DONT_MATCH_MESSAGE: 'A nova password não é a mesma.',
  GO_BACK_ACTION: 'Anterior',
  CONFIRM_ACTION: 'Confirmar',
  SIGN_OUT_ACTION: 'Sair da conta',
  OK_ACTION: 'Ok',
  CANCEL_ACTION: 'Cancelar',
  RESEND_ACTION: 'Reenviar',
  RETRY_ACTION: 'Resubmeter',
  ERROR_LABEL: 'Erro',
  SUCCESS_LABEL: 'Successo',
  ORDER_ERROR_MESSAGE: 'Houve um erro na submição da order. Por favor tente novamente.',
  ORDER_SUCCESS_MESSAGE: 'Ordem submetida com sucesso.',
  DEMO_ORDER_ERROR_MESSAGE: 'Processo de encomenda em modo demonstração concluído com sucesso.',
  DEMO_ORDER_SUCCESS_MESSAGE: 'Processo de encomenda em modo demonstração concluído com sucesso.',
  VALIDATION_POP_UP_TITLE: 'Validação de Email',
  VALIDATION_POP_UP_MESSAGE: 'Insira o codigo enviado para o seu email:',
  VALIDATION_POP_UP_ERROR: 'Código errado',
  DEMO_WARNING: 'Unicamente para efeitos de demonstração!',
  REPORT_ORDER_INFO_TITLE: 'Dados da ordem',
  REPORT_TITLE_DESCRIPTION: 'Descrição',
  REPORT_TITLE_VALUE: 'Valor',
  REPORT_TITLE_QUANTITY: 'Quant.',
  REPORT_TITLE_PRICE: 'Preço',
  REPORT_TITLE_SCREENSHOT: 'Captura de ecrã',
  REPORT_TITLE_KEY: 'Nome',
});
